export default __webpack_public_path__ + "static/power-management-dba138364b1fa5bdda9c65108811ae77.jpg";